import { STEP_TYPE_UI_CONFIG, STEP_TYPES_BY_CARD_CATEGORY } from '@/pages/Editor/types.ts';
import { useMemo } from 'react';
import { AddableStepType, StepType } from '@/types/automationFields.ts';

import { IntegrationAction } from '@/types/integrations.ts';

const useGetStepTypeConfigAndLabel = (providedStepType: StepType, action?: IntegrationAction) => {
  return useMemo(() => {
    let config = undefined;
    let stepType: AddableStepType | undefined = undefined;
    if (providedStepType === StepType.Dispatch) {
      config = STEP_TYPE_UI_CONFIG.find((s) => s.key === action?.name);
      stepType = config?.key;
    }
    if (!config) {
      stepType = providedStepType;
      config = STEP_TYPE_UI_CONFIG.find((s) => s.key === stepType)!;
    }

    const match = Object.entries(STEP_TYPES_BY_CARD_CATEGORY).find(([, value]) =>
      value.some((s) => s === stepType),
    );
    return { config, label: match?.[0] ?? 'Version-local modules' };
  }, [action?.name, providedStepType]);
};

export default useGetStepTypeConfigAndLabel;
